import { Auth } from 'aws-amplify';
import LogRocket from 'logrocket';

export const signIn = async ({ commit, dispatch }, { username, password }) => {
  try {
    commit('setUsername', username);
    const res = await Auth.signIn(username, password);
    if (res.challengeName) {
      commit('setUsername', res);
      commit('setOldPassword', password);
    }
    return res;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const completeNewPassword = async ({ dispatch }, { username, oldPassword, newPassword }) => {
  try {
    const user = await Auth.signIn(username, oldPassword);
    await Auth.completeNewPassword(user, newPassword, {});
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const signUp = async ({ commit, dispatch }, { email, username, password }) => {
  try {
    commit('setUsername', username);
    await Auth.signUp({ username, password, attributes: { email } });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const confirmSignUp = async ({ dispatch }, { username, code }) => {
  try {
    await Auth.confirmSignUp(username, code);
    dispatch('snackbar/success', 'User confirmed!', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const resendSignUp = async ({ dispatch }, { username }) => {
  try {
    await Auth.resendSignUp(username);
    dispatch('snackbar/success', 'Code has been resent. Please check your email.', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const signOut = async ({ dispatch }) => {
  try {
    await Auth.signOut();
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const changePassword = async ({ dispatch }, { oldPassword, newPassword }) => {
  try {
    await Auth.currentAuthenticatedUser()
      .then(user => Auth.changePassword(user, oldPassword, newPassword));
    dispatch('snackbar/success', 'Password changed', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const forgotPassword = async ({ commit, dispatch }, { username }) => {
  try {
    commit('setUsername', username);
    await Auth.forgotPassword(username);
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const forgotPasswordSubmit = async ({ dispatch }, { username, code, newPassword }) => {
  try {
    await Auth.forgotPasswordSubmit(username, code, newPassword);
    dispatch('snackbar/success', 'Password changed', { root: true });
    return true;
  } catch (err) {
    dispatch('snackbar/warning', err.message ? err.message : err, { root: true });
    return false;
  }
};

export const loadUser = async () => {
  try {
    // TODO: replace with currentUserInfo
    await Auth.currentSession().then((user) => {
      LogRocket.identify(user.idToken.payload.sub, {
        name: user.idToken.payload['cognito:username'],
        email: user.idToken.payload.email,
      });
    });
    return true;
  } catch (err) {
    return false;
  }
};
